import yup from '../../../config/yup';

export const paycomReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('paycomReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    url: yup.string().required('URL is required'),
    query: yup.string(),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required'),
    headers: yup.string().required('Headers are required'),
  }),
});
